/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { Component } from "react"
import PropTypes from "prop-types"
import PreventClickOnDrag from "../interaction/PreventClickOnDrag"

class GroupRow extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    onMouseMove: PropTypes.func.isRequired,
    onMouseOver: PropTypes.func.isRequired,
    onMouseOut: PropTypes.func.isRequired,
    onMouseUp: PropTypes.func.isRequired,
    onMouseDown: PropTypes.func.isRequired,
    onDoubleClick: PropTypes.func.isRequired,
    onContextMenu: PropTypes.func.isRequired,
    isEvenRow: PropTypes.bool.isRequired,
    style: PropTypes.object.isRequired,
    clickTolerance: PropTypes.number.isRequired,
    group: PropTypes.object.isRequired,
    horizontalLineClassNamesForGroup: PropTypes.func,
  }

  render() {
    const {
      onContextMenu,
      onMouseMove,
      onMouseOver,
      onMouseOut,
      onDoubleClick,
      isEvenRow,
      style,
      onClick,
      clickTolerance,
      horizontalLineClassNamesForGroup,
      group,
      onMouseUp,
      onMouseDown,
      hoverIndex,
      setHoverIndex,
    } = this.props

    let classNamesForGroup = []
    if (horizontalLineClassNamesForGroup) {
      classNamesForGroup = horizontalLineClassNamesForGroup(group)
    }

    const newStyle =
      group.rowIndex === hoverIndex
        ? { ...style, backgroundColor: `#e7f1ff` }
        : style

    return (
      <PreventClickOnDrag
        clickTolerance={clickTolerance}
        onClick={onClick}
        onMouseUp={onMouseUp}
        onMouseDown={onMouseDown}
      >
        <div
          onContextMenu={onContextMenu}
          onDoubleClick={onDoubleClick}
          onMouseMove={onMouseMove}
          onMouseOver={evt => {
            onMouseOver(evt)
            setHoverIndex(group.rowIndex)
          }}
          onMouseOut={evt => {
            onMouseOut(evt)
            setHoverIndex(null)
          }}
          className={
            (isEvenRow ? `rct-hl-even ` : `rct-hl-odd `) +
            (classNamesForGroup ? classNamesForGroup.join(` `) : ``)
          }
          style={newStyle}
        />
      </PreventClickOnDrag>
    )
  }
}

export default GroupRow
